/*
 *
 * TtlCountdown
 *
 * @version 1.0.0
 * @author Magarelli_Fabrizio/DESKTOP-LBDL00N
 * @since 01-Oct-2024
 */

import TtlCountdown from './TtlCountdownContainer'

export default TtlCountdown
